type Props = {
  width?: string
  height?: string
  fill?: string
  onClick?: () => void
  className?: string
}

const CrossIcon = ({ width = '9px', height = '9px', fill = '#FF4C6A', onClick, className }: Props) => (
  <svg className={className} width={width} height={height} onClick={onClick} viewBox="0 0 9 9">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1051.000000, -122.000000)" fill={fill} fillRule="nonzero">
        <g transform="translate(928.000000, 113.000000)">
          <g>
            <g transform="translate(68.000000, 0.000000)">
              <g transform="translate(59.778175, 13.778175) rotate(45.000000) translate(-59.778175, -13.778175) translate(54.278175, 8.278175)">
                <polygon points="10.2857143 4.65306122 5.63265306 4.65306122 5.63265306 0 4.65306122 0 4.65306122 4.65306122 0 4.65306122 0 5.63265306 4.65306122 5.63265306 4.65306122 10.2857143 5.63265306 10.2857143 5.63265306 5.63265306 10.2857143 5.63265306"></polygon>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default CrossIcon
